document.addEventListener('DOMContentLoaded', function () {
    const overlay = document.getElementById('overlay');
    const popup = document.getElementById('popup');
    const closePopup = document.getElementById('closePopup');
    const submitSize = document.getElementById('submitSize');
    const result = document.getElementById('result');

    const sizeData = [
      { size: 'XS', minHeight: 154, maxHeight: 164, middleHeight: 159, minWeight: 50, maxWeight: 57 },
      { size: 'S', minHeight: 162, maxHeight: 173, middleHeight: 168, minWeight: 57, maxWeight: 68 },
      { size: 'M', minHeight: 173, maxHeight: 183, middleHeight: 178, minWeight: 68, maxWeight: 76 },
      { size: 'L', minHeight: 183, maxHeight: 190, middleHeight: 187, minWeight: 76, maxWeight: 84 },
      { size: 'XL', minHeight: 190, maxHeight: Infinity, middleHeight: 190, minWeight: 84, maxWeight: Infinity },
    ];


  const sizeButtonLink = document.querySelector("a[href='#sizeButton']");

  if (sizeButtonLink) {
        sizeButtonLink.addEventListener('click', function (event) {
      event.preventDefault(); // Prevent default anchor behavior
      overlay.style.display = 'block';
      document.getElementById('popup').style.display = 'block';
    });
  } else {
      console.warn("Element not found: a[href='#sizeButton']");
  }



    overlay.addEventListener('click', function () {
      overlay.style.display = 'none';
      popup.style.display = 'none';
    });

    closePopup.addEventListener('click', function () {
      overlay.style.display = 'none';
      popup.style.display = 'none';
    });

    function getWeightSizeIndex(weight) {
      for (let i = 0; i < sizeData.length; i++) {
        if (weight >= sizeData[i].minWeight && weight <= sizeData[i].maxWeight) {
          return i;
        }
      }
      return -1; // If weight doesn't fit any size
    }

    function subimitSizButton() {
      const height = parseInt(document.getElementById('height').value, 10);
      const weight = parseInt(document.getElementById('weight').value, 10);
      let size = '';

      for (let i = 0; i < sizeData.length; i++) {
        if (height >= sizeData[i].minHeight && height <= sizeData[i].maxHeight) {
          if (height >= sizeData[i].middleHeight) {
            size = sizeData[i].size;
            break;
          }
          const weightIndex = getWeightSizeIndex(weight);

          if (weightIndex === i) {
            size = sizeData[i].size;
            break;
          } else if (weightIndex !== -1 && weightIndex < i) {
            size = sizeData[weightIndex].size;
            break;
          }
        }

        if (i < sizeData.length - 1 && height > sizeData[i].maxHeight && height < sizeData[i + 1].maxHeight) {
          size = sizeData[i+1].size;
          break;
        }
      }

      if (size === '') {
        size = 'Size not found for the given height and weight.';
      }
      result.textContent = 'Estimated Size: ' + size;
    }
    submitSize.addEventListener('click', function () {
      subimitSizButton();
    });
  });